import { render, staticRenderFns } from "./NotStarted.vue?vue&type=template&id=3a9858b0&"
import script from "./NotStarted.vue?vue&type=script&lang=js&"
export * from "./NotStarted.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports